export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    socialColor: p => p.accentWhite,
    socialBorder: p => p.accentWhite,
    background: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    socialColor: p => p.tertiaryDark,
    socialBorder: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    navbarBg: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    socialColor: p => p.accentWhite,
    socialBorder: p => p.accentWhite,
    background: p => p.tertiaryExtraLight,
    navbarBg: p => p.tertiaryExtraLight
  }
}
